import { translate } from '@teamleader/i18n';
import React from 'react';

import PaymentBreakdown from './PaymentBreakdown';
import useCurrencyFormatter from '../../../../Components/Context/Hooks/useCurrencyFormatter';
import Box from '../../../../Components/UI/Box';
import { Invoice, MATCHED_STATUS } from '../../../../Types/invoice';
import * as styles from '../styles.css';

interface InvoicesHeaderAmount {
  invoice: Invoice;
}

const InvoicesHeaderAmount: React.FC<InvoicesHeaderAmount> = ({ invoice }) => {
  const displayedAmount =
    invoice.matchedStatus === MATCHED_STATUS.UNMATCHED ? invoice.total.due : invoice.total.payable;

  const displayedTitle =
    invoice.matchedStatus === MATCHED_STATUS.UNMATCHED ? translate('amountDue') : translate('totalAmount');

  const formatter = useCurrencyFormatter(displayedAmount.currency);

  return (
    <Box className={styles['data']}>
      <h4 className={styles['data-label']}>{displayedTitle}</h4>
      <span className={styles['data-value']}>{formatter.format(displayedAmount.amount)}</span>
      {invoice.total.due.amount !== invoice.total.payable.amount && (
        <span className={styles['data-value']}>
          <PaymentBreakdown />
        </span>
      )}
    </Box>
  );
};

export default InvoicesHeaderAmount;
